<template>
    <div class="privacy-statement-overlay">
        <div class="privacy-statement-overlay__content">
            <h3>{{ t('intro.header', { companyName }) }}</h3>
            <p>{{ t('intro.content', { companyName }) }}</p>

            <h4>{{ t('firstSection.header', { companyName }) }}</h4>
            <p>{{ t('firstSection.content', { companyName }) }}</p>

            <h4>{{ t('secondSection.header', { companyName }) }}</h4>
            <p>{{ t('secondSection.content', { companyName }) }}</p>

            <h4>{{ t('thirdSection.header', { companyName }) }}</h4>
            <p>{{ t('thirdSection.content', { companyName }) }}</p>

            <h4>{{ t('fourthSection.header', { companyName }) }}</h4>
            <p>{{ t('fourthSection.content', { companyName }) }}</p>

            <h4>{{ t('fifthSection.header', { companyName }) }}</h4>
            <p>{{ t('fifthSection.content', { companyName }) }}</p>

            <h4>{{ t('sixthSection.header', { companyName }) }}</h4>
            <p>{{ t('sixthSection.content', { companyName }) }}</p>

            <h4>{{ t('seventhSection.header', { companyName }) }}</h4>
            <p>{{ t('seventhSection.content', { companyName }) }}</p>
        </div>

        <button
            class="privacy-statement-overlay__button"
            type="button"
            @click="onOkClicked"
        >
            {{ t('ok') }}
        </button>
    </div>
</template>

<script setup lang="ts">
    import useConfiguration from '@/composables/useConfiguration';
    import useWidgetState from '@/composables/useWidgetState';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import messages from './PrivacyStatementOverlay.messages.json';

    const { t } = useI18n({ messages });

    const { assistent } = useConfiguration();
    const { showPrivacyStatementOverlay } = useWidgetState();

    const companyName = computed(() => {
        return assistent.value?.brand?.name ?? '';
    });

    async function onOkClicked() {
        showPrivacyStatementOverlay.value = false;
    }
</script>

<style scoped lang="scss">
    .privacy-statement-overlay {
        background-color: white;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 2rem;
        gap: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-top: solid 1px lightgray;
        max-height: 100%;

        h3 {
            color: var(--color-widget);
            margin-bottom: .5rem;
        }

        h4 {
            margin-top: 1rem;
        }

        &__content {
            overflow-y: scroll;
        }

        &__button {
            background-color: var(--color-widget);
            color: var(--color-widget-text);
            border: none;
            font-weight: bold;
            border-radius: 10px;
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: .5rem 3rem .5rem 3.5rem;

            &:hover {
                filter: brightness(1.1);
            }

            &--disabled {
                background-color: #c3c3c3;
                cursor: unset;

                &:hover {
                    filter: none;
                }
            }
        }
    }
</style>
